import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/roth-conversion-analyzer',
  component: () => import('../../routes/RothConversionAnalyzer.svelte'),
  card: {
    id: 'roth-conversion-analyzer',
    title: 'Roth Conversion Analyzer',
    description: 'Compare Roth conversion strategies vs. traditional accounts. See the tax impact of converting now versus paying taxes later at withdrawal.',
    icon: 'currency_exchange',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/roth-conversion-analyzer',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Roth Conversion Analyzer – Traditional vs. Roth IRA Comparison',
    description: 'Free Roth conversion analyzer. Compare whether converting your traditional IRA or 401(k) to a Roth makes sense based on your current and retirement tax rates.',
  },
};

export default meta;
